import { createRef, useContext, useEffect } from "react";
import JSONSchemaForm from "@rjsf/core";
import useGet from "./useGet";
import useUpdate from "./useUpdate";
import { EditActionContext } from "./EditActionContext";
import BeelditGenericForm from "@beeldit/core/components/BeelditGenericForm";
import { ListActionContext } from "../list/ListActionContext";
import { FloppyDisk, PlusCircle, TrashSimple, CalendarPlus } from "@phosphor-icons/react";
import useInitialize from "./useInitialize";
import useStore from "./useStore";
import { showSuccessMessage } from "@beeldit/core/helpers/messagesHelper";
import { Customer } from "@main/customers/models/Customer";
import { useNavigate, useParams } from "react-router-dom";

function useEditAction(
  modelConfig: any,
  index: any,
  setTableFilters: any,
  prepareRemoveFunction: any
): any {
  const navigate = useNavigate();
  const { tenantId, commerceId } = useParams();
  
  const initialize = useInitialize();
  const initializeFunction = () => initialize();

  /**
   * Form store success function definition
   */
  const onSuccessStore = (newElement: Customer) => {
    setElement(newElement);
    showSuccessMessage("Cliente creado correctamente");
  };

  const store = useStore(modelConfig);
  const storeFunction = () => store(onSuccessStore);

  const get = useGet(modelConfig);
  const getFunction = (id: number) => get(id);

  /**
   * Form store success function definition
   */
  const onSuccessUpdate = () => {
    showSuccessMessage("Cliente actualizado correctamente");
  };

  const update = useUpdate(modelConfig);
  const updateFunction = () => update(onSuccessUpdate);

  /** Creation and edition modal element definition */
  const contextInstance = useContext(EditActionContext);
  const { element, setElement, loading } = contextInstance;

  const { tableData } = useContext(ListActionContext);

  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      if (element && element.id) {
        updateFunction();
      } else {
        storeFunction();
      }
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    contextInstance: contextInstance,
  };

  useEffect(() => {
    // Si tras una búsqueda solo hay un elemento entonces hacemos el get
    if (tableData.elements.length === 1) {
      getFunction(tableData.elements[0].id);
    }
    // Removido: ya no inicializamos automáticamente el formulario vacío
  }, [tableData.elements]);

  const editionMode = () => {
    return element && element.id;
  };

  const actionTemplate = (
    <>
      <div className="mt-5">
        <div className="d-flex justify-content-start align-items-center mb-3">

          {/* Botón para añadir mascotas a la derecha */}          
          <button
            type="button"
            className="mb btn btn-outline-primary"
            onClick={() => {
              initializeFunction();
              setTableFilters(null);
            }}
          >
            <PlusCircle size={25} ></PlusCircle> Crear cliente 
          </button>
          <button
            type="button"
            className="ms-3 mb btn btn-outline-primary"
            disabled={loading}
            onClick={() => {
              formRef.current?.formElement.current.requestSubmit();
            }}
          >
            <FloppyDisk size={25} ></FloppyDisk> Guardar datos
          </button>
          {editionMode() && (
            <button
              type="button"
              className="ms-3 mb btn btn-success"
              onClick={() => {
                navigate(`/panel/${tenantId}/${commerceId}/booking?customer_id=${element.id}`);
              }}
            >
              <CalendarPlus size={25}></CalendarPlus> Crear reserva
            </button>
          )}
          {editionMode() && (
            <button
            type="button"
            className="ms-3 mb btn btn-outline-danger"
            onClick={() => {
              prepareRemoveFunction(element.id);
            }}
          >
            <TrashSimple size={25}></TrashSimple> Borrar cliente 
          </button>
          )}
                    
        </div>

        <BeelditGenericForm
          key={element ? element.id : 0}
          formConfig={formConfig}
          modelConfig={modelConfig}
        />
      </div>
    </>
  );

  /** END EDIT FORM ACTION */

  return {
    getFunction,
    actionTemplate,
  };
}

export default useEditAction;
